"use client";
import React, { ReactNode, memo } from "react";
import { Box, BoxProps, InputLabel } from "@mui/material";
import { DocumentIcon } from "@/icons";
import { twMerge } from "tailwind-merge";

const AppFormControlLayoutPanel = ({
  children,
  title,
  sx,
  titleProps,
  actions,
  icon = <DocumentIcon color="primary" />,
  required = false,
  ...otherProps
}: AppFormControlLayoutPanelProps) => {
  return (
    <Box
      {...otherProps}
      className={twMerge(
        "w-full rounded-1 bg-white p-0",
        otherProps?.className
      )}
    >
      {title && (
        <Box
          className="flex flex-row items-center justify-between mb-4 "
          {...titleProps}
        >
          <Box className="flex flex-row items-center h5 gap-2">
            {icon}
            <InputLabel className="h5 font-semibold">
              {title}{" "}
              {required && (
                <Box className="text-error" component={"span"}>
                  *
                </Box>
              )}
            </InputLabel>
          </Box>
          {actions}
        </Box>
      )}
      {children}
    </Box>
  );
};

export type AppFormControlLayoutPanelProps = Omit<BoxProps, "title"> & {
  title?: ReactNode;
  icon?: ReactNode;
  titleProps?: BoxProps;
  actions?: ReactNode;
  required?: boolean;
};

export default memo(AppFormControlLayoutPanel);
